import styled from "styled-components";

export const Wrapper = styled.button`
	background: #fafafa;
	border: none;
	height: ${(props) => (props.desktop ? "160px" : "132px")};
	width: ${(props) => (props.desktop ? "185px" : "132px")};
	border-radius: 8px;
	box-shadow: -2px 4px 4px -2px rgba(0, 0, 0, 0.2);
	font-size: 16px;
	font-family: "Montserrat", sans-serif;
	:hover,
	:active {
		cursor: pointer;
		background: #fcf1ff;
		border: 1px solid #a157b0;
	}
`;
